import React, { Component } from 'react';
const canUseDOM = !!(
  (typeof window !== 'undefined' &&
    window.document && window.document.createElement)
);

export default class Tawk extends Component {
  static displayName = 'Tawk';

  constructor(props) {
    super(props);

    const {
      appID,
    } = props;
    if (!appID || !canUseDOM) {
      return;
    }

    if (!window.Tawk_API.showWidget) {
      (function(w, d, id, s, x) {
        function i() {
          i.c(arguments);
        }
        i.q = [];
        i.c = function(args) {
          i.q.push(args);
        };
        w.Tawk = i;
        s = d.createElement('script');
        s.async = 1;
        s.src = 'https://embed.tawk.to/' + id + '/default';
        s.charset='UTF-8';
        s.setAttribute('crossorigin','*');
        d.head.appendChild(s);
      })(window, document, appID);
    } else {
      window.Tawk_API.showWidget();
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  componentWillUnmount() {
    if (!canUseDOM || !window.Tawk_API) return false;
    if (window.Tawk_API.hideWidget) {
      window.Tawk_API.hideWidget();
    }
  }

  render() {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/components/tawk/Tawk.js